import { render } from "./CardAttachmentCard.vue?vue&type=template&id=bb41b30c&scoped=true"
import script from "./CardAttachmentCard.vue?vue&type=script&lang=js"
export * from "./CardAttachmentCard.vue?vue&type=script&lang=js"

import "./CardAttachmentCard.vue?vue&type=style&index=0&id=bb41b30c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb41b30c"]])

export default __exports__